import Vue from 'vue';
import * as VueGoogleMaps from 'gmap-vue';
import store from '@/store/store';
import QUADRA_DIFFUSION_API_KEY_GOOGLE_MAP from '@/configuration/general/googleMapApiKeyConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

export default async function initialiseGmapComponent() {
  let googleMapApiKey = await store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.googleMapApiKey.key);
  if (!googleMapApiKey || googleMapApiKey === '') {
    googleMapApiKey = QUADRA_DIFFUSION_API_KEY_GOOGLE_MAP;
  }
  Vue.use(VueGoogleMaps, {
    load: {
      key: googleMapApiKey,
      libraries: 'places',
    },
  });
}
